// OWA Fluent UI preset colours (preset0–preset24)
const PRESET_COLORS = {
  preset0:  '#e81123', // Red
  preset1:  '#ca5010', // Orange
  preset2:  '#8e562e', // Brown
  preset3:  '#986f0b', // Yellow
  preset4:  '#107c10', // Green
  preset5:  '#008272', // Teal
  preset6:  '#767676', // Olive
  preset7:  '#0078d4', // Blue
  preset8:  '#5c2d91', // Purple
  preset9:  '#c50f1f', // Cranberry
  preset10: '#69797e', // Steel
  preset11: '#4e5458', // DarkSteel
  preset12: '#7a7574', // Gray
  preset13: '#393939', // DarkGray
  preset14: '#1b1a19', // Black
  preset15: '#750b1c', // DarkRed
  preset16: '#d13438', // DarkOrange
  preset17: '#603d30', // DarkBrown
  preset18: '#835b00', // DarkYellow
  preset19: '#0b6a0b', // DarkGreen
  preset20: '#004b50', // DarkTeal
  preset21: '#3b3a00', // DarkOlive
  preset22: '#003966', // DarkBlue
  preset23: '#32145a', // DarkPurple
  preset24: '#6e0811', // DarkCranberry
};

// Per-category colour overrides matched from OWA Categories settings screen
const CATEGORY_COLORS = {
  'Cristie':           '#c50f1f', // Cranberry / Pink-Rose
  'Dee':               '#69797e', // Steel Blue
  'Haley':             '#8764b8', // Light Lavender Purple
  'Iris':              '#5c2d91', // Purple
  'Kay':               '#5c2d91', // Purple
  'Kim':               '#107c10', // Green
  'Ling':              '#ca5010', // Peach / Orange
  'New Request':       '#e81123', // Red
  'PH - Wei':          '#881798', // Purple-Mauve / Berry
  'Steph':             '#498205', // Light Green
  'Student - Evelyn':  '#8e562e', // Brown
  'Student - Sabrina': '#008272', // Teal
  'Student - Vivi':    '#ca5010', // Peach / Orange
  'Sue':               '#69797e', // Steel Blue
  'T1 - Wei':          '#107c10', // Green
  'T2 - Ana':          '#c50f1f', // Cranberry / Rose
  'T2 - Catherine':    '#e3008c', // Hot Pink
  'T3 - Eulyces':      '#7a7574', // Gray
  'Tessy':             '#008272', // Teal
  'URGENT':            '#0078d4', // Blue
};

// Hardcoded category list used when masterCategories API is unavailable (403 with app-only auth)
export const KNOWN_CATEGORIES = [
  'Cristie', 'Dee', 'Haley', 'Iris', 'Kay', 'Kim', 'Ling',
  'New Request', 'PH - Wei', 'Steph', 'Student - Evelyn',
  'Student - Sabrina', 'Student - Vivi', 'Sue', 'T1 - Wei',
  'T2 - Ana', 'T2 - Catherine', 'T3 - Eulyces', 'Tessy', 'URGENT',
].map(name => ({ displayName: name, color: null }));

export function categoryColor(colorPreset, displayName) {
  if (displayName && CATEGORY_COLORS[displayName]) return CATEGORY_COLORS[displayName];
  return PRESET_COLORS[colorPreset] || '#767676';
}

// Resolve a colour given only the display name
export function colorByName(displayName) {
  return CATEGORY_COLORS[displayName] || '#767676';
}

export function buildCategoryMap(categories) {
  const map = {};
  for (const c of categories) map[c.displayName] = categoryColor(c.color, c.displayName);
  return map;
}
